import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import API_URL from '../../api/API';

const BusinessVerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    let called = false;
  
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Verification token is missing.');
      return;
    }
  
    const verifyEmail = async () => {
      if (called) return;
      called = true;
  
      try {
        const res = await fetch(`${API_URL.BUSINESS_VERIFY_EMAIL}?token=${token}`);
        const data = await res.json();
  
        if (res.ok && data.success) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully.');
        } else {
          setStatus('error');
          setMessage(data.message || 'Verification failed.');
        }
      } catch (err) {
        console.error('Error during verification:', err);
        setStatus('error');
        setMessage('Server error during verification. Please try again.');
      }
    };
  
    verifyEmail();
  }, [searchParams]);
  

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white p-6 rounded shadow text-center">
        {status === 'verifying' && (
          <p className="text-gray-700">Verifying your email...</p>
        )}

        {status === 'success' && (
          <>
            <p className="text-green-600 font-semibold">{message}</p>
            <button
              onClick={() => navigate('/business/login')}
              className="mt-4 bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition"
            >
              Go to Login
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <p className="text-red-600 font-semibold">{message}</p>
            <button
              onClick={() => navigate('/business/register')}
              className="mt-4 text-sm text-gray-600 underline"
            >
              Try Again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default BusinessVerifyEmail;
